export const INSTANCE = 'app-instance';
export const TAX_CODE_WIZARD = 'tax-code-wizard';
export const TROUBLESHOOTING = 'troubleshooting';
export const BANK_DETAILS = 'bankDetails';
